import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ExploreProducerItem } from "@/types/exploreProducer";

async function fetchExploreProducers(): Promise<ExploreProducerItem[]> {
  const { data, error } = await supabase
    .from("producers")
    .select("id, name, slug, short_description, city, region, lat, lng, categories, verified, has_farm_shop, has_farm_sale_alcohol")
    .eq("status", "public")
    .not("published_at", "is", null)
    .order("name");

  if (error) throw error;

  return (data || []).map((p) => ({
    id: p.id,
    kind: "producer" as const,
    slug: p.slug,
    name: p.name,
    subtitle: [p.city, p.region].filter(Boolean).join(", "),
    shortDescription: p.short_description,
    categories: (p.categories as string[]) || [],
    lat: p.lat,
    lng: p.lng,
    coverImageUrl: null, // Resolved from media_assets via useCoverAsset
    verified: !!p.verified,
    href: `/producer/${p.slug || p.id}`,
    hasFarmShop: p.has_farm_shop ?? false,
    hasFarmSaleAlcohol: p.has_farm_sale_alcohol ?? false,
  }));
}

export function useExploreProducers(enabled = true) {
  return useQuery({
    queryKey: ["explore-producers"],
    queryFn: fetchExploreProducers,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
